<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <!-- * 确认窗口 -->
        <confirm-modal ref="confirm" :width="648" height="auto" @confirm="methods.confirm">{{ $t("PredictionMutationDELConfirm") }}</confirm-modal>
        <ui-modal ref="info" height="auto" spacing="32px 56px 40px">
            <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("ModelIntroduction") }}</div>
            <div class="mt-[16px]">
                <p>{{ $t("VPPDescript1") }}</p>
                <p class="mt-[8px]">{{ $t("VPPDescript2") }}</p>
            </div>
        </ui-modal>

        <div :class="css.container">
            <section :class="css.main" class="container">
                <h1 :class="css.name">{{ $t("VPP") }}</h1>
                <div :class="css.description" class="text-center">{{ $t("VPPDescript3") }}</div>
                <div :class="css.inputs">
                    <mutations-inputs ref="inputs" mode="Pathogenicity" :species="['Human']" v-on="ons.inputs" />
                </div>
            </section>

            <section :class="css.why" class="container">
                <h2 :class="css.name">{{ $t("VPPFAQName1") }}</h2>
                <div :class="css.content">
                    <div :class="css.descriptions">
                        <div>{{ $t("VPPFAQ1Answer1") }}</div>
                        <div>{{ $t("VPPFAQ1Answer2") }}</div>
                        <div>{{ $t("VPPFAQ1Answer3") }}</div>
                        <div>{{ $t("VPPFAQ1Answer4") }}</div>
                    </div>

                    <div :class="css.descriptions">
                        <i18n-t tag="div" scope="global" keypath="VPPFAQ1Answer5">
                            <template v-slot:name>
                                <span class="font-bold text-main">{{ $t("VPP") }}</span>
                            </template>
                        </i18n-t>
                        <div>{{ $t("VPPFAQ1Answer6") }}</div>
                        <div>{{ $t("VPPFAQ1Answer7") }}</div>
                    </div>

                    <div :class="css.descriptions">
                        <div>{{ $t("VPPFAQ1Answer8") }}</div>
                        <div>{{ $t("VPPFAQ1Answer9") }}</div>
                        <div>{{ $t("VPPFAQ1Answer10") }}</div>
                        <div>{{ $t("VPPFAQ1Answer11") }}</div>
                    </div>

                    <div :class="css.descriptions">{{ $t("VPPFAQ1Answer12") }}</div>
                </div>
            </section>

            <section :class="css.try" class="container">
                <h2 :class="css.name">{{ $t("TryNow") }}</h2>
                <div :class="css.inputs">
                    <mutations-inputs mode="Pathogenicity" :species="['Human']" :explain="false" v-on="ons.inputs" />
                </div>
            </section>

            <section :class="css.explains" class="container">
                <h2 :class="css.name">{{ $t("DetailedOperatingSteps") }}</h2>
                <div :class="css.video">
                    <iframe
                        src="//player.bilibili.com/player.html?isOutside=true&aid=114341005238133&bvid=BV1TcdZY9ERF&cid=29422519964&p=1"
                        scrolling="no"
                        border="0"
                        frameborder="no"
                        framespacing="0"
                        allowfullscreen="true"
                        v-if="$i18n.locale == 'zh'" />

                    <iframe
                        src="https://www.youtube.com/embed/80LG-yoZnIk?si=FKJYOKv3qOVHkdsn"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                        v-else />
                </div>

                <div :class="css.stepses">
                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("VPPOperatingSteps1") }}</h3>
                        <div :class="css.image">
                            <img v-src="1" />
                        </div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("VPPOperatingSteps2") }}</h3>
                        <div>{{ $t("VPPOperatingSteps2Description1") }}</div>
                        <div :class="css.image">
                            <img v-src="2" />
                        </div>

                        <div :class="css.emphasis">{{ $t("VPPOperatingSteps2Description2") }}</div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("VPPOperatingSteps3") }}</h3>
                        <div>{{ $t("VPPOperatingSteps3Description1") }}</div>
                        <div>{{ $t("VPPOperatingSteps3Description2") }}</div>
                        <div :class="css.image">
                            <img v-src="3" />
                        </div>

                        <div :class="css.emphasis">{{ $t("VPPOperatingSteps3Description3") }}</div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("VPPOperatingSteps4") }}</h3>
                        <div>{{ $t("VPPOperatingSteps4Description1") }}</div>
                        <div>{{ $t("VPPOperatingSteps4Description2") }}</div>
                        <div :class="css.image">
                            <img v-src="4" />
                        </div>

                        <i18n-t tag="div" scope="global" keypath="VPPOperatingSteps4Description3">
                            <template v-slot:name>
                                <span :class="css.emphasis">{{ $i18n.locale == "zh" ? "【展开图表】" : "[Expand Diagram]" }}</span>
                            </template>
                        </i18n-t>

                        <div :class="css.emphasis">{{ $t("VPPOperatingSteps4Description4") }}</div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("VPPOperatingSteps5") }}</h3>
                        <div>{{ $t("VPPOperatingSteps5Description1") }}</div>
                        <div>{{ $t("VPPOperatingSteps5Description2") }}</div>
                        <div>{{ $t("VPPOperatingSteps5Description3") }}</div>
                        <div :class="css.image">
                            <img v-src="5" />
                        </div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("VPPOperatingSteps6") }}</h3>
                        <div>{{ $t("VPPOperatingSteps6Description1") }}</div>
                        <div>{{ $t("VPPOperatingSteps6Description2") }}</div>
                        <div :class="css.image">
                            <img v-src="6" />
                        </div>

                        <div>{{ $t("VPPOperatingSteps6Description3") }}</div>
                        <div :class="css.image">
                            <img v-src="7" />
                        </div>

                        <div>{{ $t("VPPOperatingSteps6Description4") }}</div>
                        <div :class="css.image">
                            <img v-src="8" />
                        </div>

                        <div :class="css.emphasis">{{ $t("VPPOperatingSteps6Description5") }}</div>
                    </div>

                    <div :class="css.steps">
                        <h3 :class="css.name">{{ $t("VPPOperatingSteps7") }}</h3>
                        <div>{{ $t("VPPOperatingSteps7Description1") }}</div>
                        <div :class="css.image">
                            <img v-src="9" />
                        </div>

                        <div :class="css.emphasis">{{ $t("VPPOperatingSteps7Description2") }}</div>
                    </div>
                </div>
            </section>

            <section :class="css.try" class="container">
                <h2 :class="css.name">{{ $t("VPPTryNow") }}</h2>
                <div :class="css.inputs">
                    <mutations-inputs mode="Pathogenicity" :species="['Human']" :explain="false" v-on="ons.inputs" />
                </div>
            </section>

            <section :class="css.scenes" class="container">
                <h2 :class="css.name">{{ $t("ApplicationScenarios") }}</h2>
                <div :class="css.content">
                    <div :class="css.scene">
                        <h3 :class="css.name">{{ $t("ResearchScenario") }}</h3>
                        <div :class="css.rect"></div>
                        <div :class="css.description">{{ $t("VPPResearchScenarioDescription1") }}</div>
                        <div :class="css.explain">
                            <div :class="css.tap">{{ $t("Example") }}</div>
                            <div :class="css.context">{{ $t("VPPResearchScenarioDescription2") }}</div>
                        </div>
                    </div>
                    <div :class="css.scene">
                        <h3 :class="css.name">{{ $t("ClinicalScenario") }}</h3>
                        <div :class="css.rect"></div>
                        <div :class="css.description">{{ $t("VPPClinicalScenarioDescription1") }}</div>
                        <div :class="css.explain">
                            <div :class="css.tap">{{ $t("Example") }}</div>
                            <div :class="css.context">{{ $t("VPPClinicalScenarioDescription2") }}</div>
                        </div>
                    </div>
                    <div :class="css.scene">
                        <h3 :class="css.name">{{ $t("EducationScenario") }}</h3>
                        <div :class="css.rect"></div>
                        <div :class="css.description">{{ $t("VPPEducationScenarioDescription1") }}</div>
                        <div :class="css.explain">
                            <div :class="css.tap">{{ $t("Example") }}</div>
                            <div :class="css.context">{{ $t("VPPEducationScenarioDescription2") }}</div>
                        </div>
                    </div>
                    <div :class="css.scene">
                        <h3 :class="css.name">{{ $t("IndustryScenario") }}</h3>
                        <div :class="css.rect"></div>
                        <div :class="css.description">{{ $t("VPPIndustryScenarioDescription1") }}</div>
                    </div>
                </div>
            </section>

            <section :class="css.reminders" class="container">
                <h2 :class="css.name">{{ $t("HelpfulTips") }}</h2>
                <div :class="css.content">
                    <div :class="css.reminder">
                        <h3 :class="css.name">{{ $t("VPPHelpfulTips1") }}</h3>
                        <div :class="css.description">{{ $t("VPPHelpfulTips1Description1") }}</div>
                    </div>

                    <div :class="css.reminder">
                        <h3 :class="css.name">{{ $t("VPPHelpfulTips2") }}</h3>
                        <div :class="css.description">{{ $t("VPPHelpfulTips2Description1") }}</div>
                    </div>

                    <div :class="css.reminder">
                        <h3 :class="css.name">{{ $t("VPPHelpfulTips3") }}</h3>
                        <div :class="css.description">{{ $t("VPPHelpfulTips3Description1") }}</div>
                    </div>

                    <div :class="css.reminder">
                        <h3 :class="css.name">{{ $t("VPPHelpfulTips4") }}</h3>
                        <div :class="css.description">{{ $t("VPPHelpfulTips4Description1") }}</div>
                    </div>

                    <div :class="css.reminder">
                        <h3 :class="css.name">{{ $t("VPPHelpfulTips5") }}</h3>
                        <div :class="css.description">
                            <div>{{ $t("VPPHelpfulTips5Description1") }}</div>
                            <div>{{ $t("VPPHelpfulTips5Description2") }}</div>
                        </div>
                    </div>
                </div>
            </section>

            <section :class="css.try" class="container">
                <h2 :class="css.name">{{ $t("VPPStartYourPredictionNow") }}</h2>
                <div :class="css.inputs">
                    <mutations-inputs mode="Pathogenicity" :species="['Human']" :explain="false" v-on="ons.inputs" />
                </div>
            </section>

            <section :class="css.faqs" class="container">
                <h2 :class="css.name">{{ $t("VPPFAQs") }}</h2>
                <div :class="css.content">
                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q1</div>
                            <div :class="css.context">{{ $t("VPPFAQIssue1") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("VPPFAQAnswer1") }}</div>
                    </div>

                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q2</div>
                            <div :class="css.context">{{ $t("VPPFAQIssue2") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("VPPFAQAnswer2") }}</div>
                    </div>

                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q3</div>
                            <div :class="css.context">{{ $t("VPPFAQIssue3") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("VPPFAQAnswer3") }}</div>
                    </div>

                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q4</div>
                            <div :class="css.context">{{ $t("VPPFAQIssue4") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("VPPFAQAnswer4") }}</div>
                    </div>

                    <div :class="css.faq">
                        <h3 :class="css.issue">
                            <div :class="css.tap">Q5</div>
                            <div :class="css.context">{{ $t("VPPFAQIssue5") }}</div>
                        </h3>

                        <div :class="css.answer">{{ $t("VPPFAQAnswer5") }}</div>
                    </div>
                </div>
            </section>

            <section :class="css.recommendeds" class="container">
                <h2 :class="css.name">{{ $t("VPPRecommendedTools") }}</h2>
                <div :class="css.content">
                    <ProjectRoute :class="css.tool" v-for="(value, key) in options.recommendeds" :to="value.route" :key="key">
                        <img :class="css.cover" :src="value.img" :alt="value.name" />
                        <div :class="css.info">
                            <h3 :class="css.name">{{ value.name }}</h3>
                            <div :class="css.description">{{ value.descript }}</div>
                        </div>
                    </ProjectRoute>
                </div>
            </section>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* Vue
import type { Directive } from "vue";
//* 组件库
import { UiModal, $loading } from "various-ui";
//* 公共组件
import { ConfirmModal } from "@/components/windows";
//* 私有组件
import MutationsInputs from "../../../components/mutations-inputs/index.vue";
//* 公共函数
import { Formats } from "@/assets/js";
//* 组件属性
import type { ModuleFormData } from "../../../components/mutations-inputs/src/types";
import { useOptions } from "./src/options";
//* 样式
import css from "./index.module.less";

//* 图片资源导入
const images = import.meta.glob("./src/images/*/*.webp", { query: "url", import: "default" });

//* 插件
const i18n = useI18n();
const route = useRoute();
//* 配置
const options = useOptions();
//* 节点
const nodes = {
    info: useTemplateRef<InstanceType<typeof UiModal>>("info"),
    confirm: useTemplateRef<InstanceType<typeof ConfirmModal>>("confirm"),
    inputs: useTemplateRef<InstanceType<typeof MutationsInputs>>("inputs"),
};

//* 函数列表
const methods = {
    //* 确认函数
    confirm: (response: { datas: ModuleFormData[]; syns: boolean }) => {
        console.log("表单提交数据：", response);
        //* 数据处理
        $loading.open({ message: i18n.t("UnderLoad"), delay: 200 });
        const data = response.datas.map((v) => {
            return {
                gene_id: v.id,
                gene_pos: v.data.range?.start || -1,
                gene_name: v.name,
                reference: v.ref,
                alteration: v.alt,
                mutation_name: v.mode == "Paste" || v.mode == "Variant" ? v.data.keyword : undefined,
                transcript_id: v.transcript,
            };
        });

        //* 接口请求
        api.frontend("/api/ai/pathogenicity", {
            data: { data: data, splicer: response.syns },
            method: "POST",
            finally: () => $loading.close(),
            success: (id) => {
                window.open(routerResolve({ name: "PathogenicityResult", params: { id: id } }).href, "_blank");
            },
        });
    },

    //* 跳转函数
    image: () => open(routerResolve({ name: "PathogenicityTutorials" }).href, "_blank"),
    next: () => {
        if (i18n.locale.value == "zh") open("https://www.bilibili.com/video/BV1TcdZY9ERF", "_blank");
        else {
            open("https://www.youtube.com/watch?v=80LG-yoZnIk", "_blank");
        }
    },
};

//* 响应事件
const ons = {
    inputs: {
        info: () => nodes.info.value?.openModal(),
        video: methods.next,
        image: methods.image,
        submit: (response: { datas: ModuleFormData[]; syns: boolean }) => {
            if (response.datas.find((v) => !v.alt)) nodes.confirm.value?.open(response);
            else {
                methods.confirm(response);
            }
        },
    },
};

//* 指令
const vSrc: Directive<HTMLImageElement, string | number> = {
    created: (_node, response, vnode) => {
        images[`./src/images/${i18n.locale.value}/${response.value.toString()}.webp`]?.().then((src) => {
            vnode.el.src = src;
        });
    },
};

//* 组件挂载时通过URL参数获取数据
onMounted(() => {
    const uid = Formats.query(route.query.uuid);
    if (!uid) return;
    else {
        $loading.open({ message: "" });
        api.frontend("/api/bio/variant/params", {
            data: { id: uid },
            error: () => $loading.close(),
            hidden: true,
            success: (response) => {
                //* 表单初始化
                nextTick(() => {
                    nodes.inputs.value?.init(response);
                });
            },
        });
    }
});
</script>
